var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tipsBox",style:(_vm.toastStyle)},[(_vm.isShow)?_c('div',{staticClass:"content",style:({'background-color': _vm.theme})},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }